import styled from "styled-components";

const CustomsStatusViewStyled = styled.div`

background: white;
border-radius: 8px;
padding:  16px ;
display: flex;
flex-direction: column;
gap: 12px;
width: 100%;

 & > button {
    width: 100% !important;
    min-height: 42px !important;
    max-height: 42px !important;
    padding: 10px 24px !important;
    font-size: 1.6rem !important;
 }

.title {
    font-size: 1.4rem;
    font-weight: 700;
}

.description { 
    font-size: 1.3rem;
    font-weight: 400;
}

@media only screen and (min-width: ${props => props.theme.desktopSmall}) {
  .title {
    font-size: 1.6rem;
    font-weight: 700;
  }

  .description { 
      font-size: 1.4rem;
      font-weight: 400;
  }

  .bn {
    width: 21.6rem !important;
    min-height: 4.2rem !important;
    max-height: 4.2rem !important;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
}`

export { CustomsStatusViewStyled };